// extracted by mini-css-extract-plugin
export default {"servicesFrame":"screenServices_servicesFrame__m95KD"};